/* eslint-disable max-lines */
import { css } from 'linaria';

export const newBathroomRepairProfessional = css`
  margin-bottom: 44px;

  @media (--only-mobile) {
    margin-bottom: 40px;
  }
`;

export const newBathroomRepairProfessionalTitle = css`
  @media (--to-largeDesktop) {
    margin-bottom: 16px;
  }
`;

export const newBathroomRepairProfessionalCard = css`
  background-color: #F5F4F1;
  border-radius: var(--rounding-l);
  display: flex;
  justify-content: space-between;
  margin-bottom: 28px;

  @media (--to-largeDesktop) {
    margin-bottom: 24px;
  }

  @media (--from-desktop) {
    height: 200px;
  }

  @media (--only-tablet) {
    height: 142px;
  }

  @media (--only-mobile) {
    flex-direction: column;
    margin-bottom: 16px;
  }
`;

export const newBathroomRepairProfessionalCardContent = css`
  padding: 30px;

  @media (--only-mobile) {
    order: 2;
    padding: 24px;
  }
`;

export const newBathroomRepairProfessionalCardTitle = css`
  white-space: break-spaces;
  margin-bottom: 16px;

  @media (--only-mobile) {
    margin-bottom: 12px;
  }
`;

export const newBathroomRepairProfessionalCardDescription = css`
  @media (--to-desktop) {
  font-size: 14px;
  line-height: 20px;
}
`;

export const newBathroomRepairProfessionalCardImage = css`
  width: 663px;
  height: 200px;
  border-radius: 0 var(--rounding-l) var(--rounding-l) 0;

  @media (--only-desktop) {
    width: 512px;
  }
  
  @media (--only-tablet) {
    width: 311px;
    height: 142px;
  }

  @media (--only-mobile) {
    width: 100%;
    height: 100%;
    border-radius: var(--rounding-l) var(--rounding-l) 0 0;
  }
`;

export const newBathroomRepairServiceGrid = css`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (--only-mobile) {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  @media (--from-desktop) {
    :nth-child(2) {
      grid-column-start: span 2;
    }

    :nth-child(3) {
      grid-column: 2;
      grid-row: 1;
    }
  }

   @media (--only-tablet) {
    :nth-child(1),
    :nth-child(2) {
      grid-column-start: span 2;
    }

    :last-child {
      grid-column-start: span 2;
    }
  }
`;

export const newBathroomRepairProfessionalService = css`
  background-color: var(--service-light);
  border-radius: var(--rounding-l);
  padding: 12px;
  display: flex;
  align-items: center;

  @media (--only-mobile) {
    align-items: flex-start;
  }
`;

export const newBathroomRepairProfessionalServiceText = css`
  padding-left: 8px;
  padding-right: 16px;
`;

export const newBathroomRepairProfessionalServicePrice = css`
  padding: 6px 12px;
  margin-left: auto;
  background-color: var(--background-primary);
  border-radius: var(--rounding-l);

  @media (--only-mobile) {
    width: fill-available;
    max-width: 89px;
  }
`;

export const newBathroomRepairServiceDisclaimer = css`
  display: flex;
  align-items: center;
  column-gap: 8px;
  padding: 4px 0;

  @media (--only-mobile) {
    align-items: flex-start;
  }
`;

export const newBathroomRepairServiceDisclaimerGrid = css`  
  @media (--from-tablet) {
    margin-top: -12px;
  }
`;

export const newBathroomRepairYourself = css`
  margin-bottom: 28px;

  @media (--only-mobile) {
    margin-bottom: 24px;
  }
`;

export const newBathroomRepairYourselfCards = css`
  display: grid;
  gap: 24px;
  grid-template-columns: repeat(4, 1fr);

  @media (--only-tablet) {
    grid-template-columns: 1fr 1fr;
  }

  @media (--only-mobile) {
    grid-template-columns: 1fr;
  }
`;

export const newBathroomRepairYourselfCardContent = css`
  padding: 24px;
  background-color: var(--background-secondary);
  height: 100%;
`;

export const newBathroomRepairYourselfCardTitle = css`
  margin-bottom: 0;
  
  @media (--to-largeDesktop) {
    font-size: 18px;
    line-height: 24px;
  }
`;
